import React, {useState} from 'react'
import {NotificationConfig} from './NotificationConfig'
import {VOSReminderSettings} from './VOSReminderSettings'
import {InterpreterReminderSettings} from './InterpreterReminderSettings'
import {AiAssignmentAgentSettings} from './AiAssignmentAgentSettings'
import UnderDevelopmentBadge from '../../../common/componenets/underDevelopment/underDevelopmentBadge'
import {MainConfig} from './MainConfig'
import {useFeatureAccess} from '../../../hooks/useFeatureAccess'
import {useAiAssignmentFeatureEnabled} from '../../../hooks/useAiAssignmentFeature'

export function EmailConfig() {
  const [activeTab, setActiveTab] = useState(1)
  const access = useFeatureAccess('emails')
  const aiAssignmentEnabled = useAiAssignmentFeatureEnabled()
  const handleTabClick = (tabNumber: React.SetStateAction<number>) => {
    setActiveTab(tabNumber)
  }
  return (
    <>
      <div className='mb-3 d-flex flex-column'>
        <div className='d-flex'>
          <h1 className='mb-0 fw-bold mb-2' style={{fontSize: '25px', lineHeight: '32px'}}>
            Email Configuration
          </h1>
        </div>
        <div className='d-flex'>
          <p className='text-gray-500 fs-5 mb-2'>
            {access === 'edit' ? 'Manage Configuration' : 'View Configuration'}
          </p>
        </div>
      </div>
      <div className='card mb-5'>
        <div
          className='card-header py-0'
          style={{minWidth: '300px', overflowX: 'auto', minHeight: '50px'}}
        >
          <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-semibold flex-nowrap'>
            <li className='nav-item'>
              <a
                className={`nav-link fs-7 text-gray-400   ${
                  activeTab === 1 ? 'text-active-dark fw-bold active show' : ''
                }`}
                data-bs-toggle='tab'
                href='#kt_tab_pane_1'
                onClick={() => handleTabClick(1)}
              >
                Notification Configuration
              </a>
            </li>
            <li className='nav-item'>
              <a
                className={`nav-link fs-7 text-gray-400   ${
                  activeTab === 2 ? 'text-active-dark fw-bold active show' : ''
                }`}
                data-bs-toggle='tab'
                href='#kt_tab_pane_2'
                onClick={() => handleTabClick(2)}
              >
                VOS Reminder Settings
              </a>
            </li>
            <li className='nav-item'>
              <a
                className={`nav-link fs-7 text-gray-400   ${
                  activeTab === 3 ? 'text-active-dark fw-bold active show' : ''
                }`}
                data-bs-toggle='tab'
                href='#kt_tab_pane_3'
                onClick={() => handleTabClick(3)}
              >
                Interpreter Reminder Settings
              </a>
            </li>
            {aiAssignmentEnabled && (
              <li className='nav-item'>
                <a
                  className={`nav-link fs-7 text-gray-400   ${
                    activeTab === 4 ? 'text-active-dark fw-bold active show' : ''
                  }`}
                  data-bs-toggle='tab'
                  href='#kt_tab_pane_4'
                  onClick={() => handleTabClick(4)}
                >
                  AI Assignment Agent
                </a>
              </li>
            )}
          </ul>
        </div>

        <div className=''>
          <div className='tab-content' id='myTabContent'>
            {activeTab === 1 && (
              <div className='tab-pane fade show active' id='kt_tab_pane_1' role='tabpanel'>
                <div className='card-body h-100vh'>
                  <NotificationConfig />
                </div>
              </div>
            )}
            {activeTab === 2 && (
              <div className='tab-pane fade show active' id='kt_tab_pane_2' role='tabpanel'>
                <div className='card-body'>
                  <VOSReminderSettings />
                </div>
              </div>
            )}
            {activeTab === 3 && (
              <div className='tab-pane fade show active' id='kt_tab_pane_3' role='tabpanel'>
                <div className='card-body'>
                  <InterpreterReminderSettings />
                </div>
              </div>
            )}
            {activeTab === 4 && aiAssignmentEnabled && (
              <div className='tab-pane fade show active' id='kt_tab_pane_4' role='tabpanel'>
                <div className='card-body'>
                  <AiAssignmentAgentSettings />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
